'use client'

import {useState} from 'react'
import { useBranchCode } from '@/components/SiteHostProvider';
import {usePathname, useSearchParams} from 'next/navigation'
import {getBranchData, getCurrentBranch} from '@/lib/config/branches-config'
import { getLeadFormBranch } from '@/lib/forms/region'
import RegionModal from './RegionModal'

interface RegionProps {
    className?: string
    asButton?: boolean // Для использования в мобильной панели как кнопка
}

export default function Region({ className = '', asButton = false }: RegionProps) {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const pathname = usePathname() || '/'
    
    // Определяем текущий регион из пути
    const pageBranchCode = useBranchCode()
    const currentBranchCode = getLeadFormBranch(pathname, useSearchParams().toString(), pageBranchCode)
    const currentBranch = getBranchData(currentBranchCode) || getCurrentBranch()

    const handleClick = () => {
        setIsModalOpen(true)
    }

    if (asButton) {
        return (
            <>
                <button
                    onClick={handleClick}
                    className={`flex items-center gap-2 ${className}`}
                    type="button"
                >
                    {currentBranch && (
                        <>
                            <img
                                src="/icon/map-pin.svg"
                                alt={currentBranch.name}
                                className="size-5 rounded-full object-cover brightness-0 invert"
                                aria-hidden="true"
                            />
                            <span className="truncate">{currentBranch.name}</span>
                        </>
                    )}
                </button>
                <RegionModal 
                    open={isModalOpen} 
                    onOpenChange={setIsModalOpen}
                    currentBranchCode={currentBranchCode}
                />
            </>
        )
    }

    return (
        <>
            <button
                onClick={handleClick}
                className={`flex items-center gap-2 rounded-xl bg-gray-400/5 px-5 py-3 text-sm font-semibold text-gray-900 shadow-xs hover:bg-gray-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white ${className}`}
                type="button"
            >
                {currentBranch && (
                    <>
                        <img
                            src="/icon/map-pin.svg"
                            alt={currentBranch.name}
                            className="size-5 rounded-full object-cover brightness-0 invert"
                            aria-hidden="true"
                        />
                        <span className="truncate hidden xl:inline">{currentBranch.name}</span>
                    </>
                )}
            </button>
            <RegionModal 
                open={isModalOpen} 
                onOpenChange={setIsModalOpen}
                currentBranchCode={currentBranch.code}
            />
        </>
    )
}

